export const RECRUITER = 'RECRUITER'
export const MANAGER = 'MANAGER'
export const SELECTION_COMMITTEE = 'SELECTION_COMMITTEE'
